import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { message } from 'antd';
import firebase from "firebase/compat/app";
import { auth } from "../../../apis/firebase_authentications";
import * as FetchData from "../../../apis/FetchData";
import { addToBookmark, deleteBookmark } from "../../../apis/PostData";
import { getTranslationDirection } from "../../../assets/js/translationDirection";
import ReadVerseModalUi from "../Ui/ReadVerseModal";
import shuffleIcon from '../../../assets/images/shuffle.svg';
import shuffleIconWhite from '../../../assets/images/shuffleWhite.svg';
import arrow_down_blue from '../../../assets/images/arrow_down_blue.svg';
import arrow_down_White from '../../../assets/images/arrow_down_white.svg';
import move_next from '../../../assets/images/move_next.svg';
import move_nextWhite from '../../../assets/images/move_nextWhite.svg';
import move_previous from '../../../assets/images/move_previous.svg';
import move_previousWhite from '../../../assets/images/move_previousWhite.svg';
import play_black from '../../../assets/images/play_black.svg';
import play_White from '../../../assets/images/play_white.svg';
import pause_black from '../../../assets/images/pause_black.svg';
import pause_White from '../../../assets/images/pause_white.svg';
import { convertToSearchableChapters } from '../../Views/Logic/SearchableChapters';
import CopyVerseGray from "../../../assets/images/CopyVerseGray.svg";
import CopyVerseWhite from "../../../assets/images/CopyVerse.svg";
import { SettingsReducer } from "../../../redux/Setting";
const SettingActions = SettingsReducer.actions;
const { FindAllTranslations, findAllTranslationsWithPagination, fetchRecitationAudio } = FetchData;

export default function ReadVerseModal(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chapters = useSelector((state) => state.chapters);
  const reciterNames = useSelector((state) => state.chapters.reciters);
  const selectedReciterId = useSelector((state) => state.settings.selectedReciterId);
  const selectedReciterName = useSelector((state) => state.settings.selectedReciterName);
  const selectedTranslations = useSelector((state) => state.settings.selectedTranslations);
  const showTranslation = useSelector((state) => state.settings.showTranslation);
  const jumpToVerse = useSelector((state) => state.settings.jumpToVerse);
  const arabicFontSize = useSelector((state) => state.settings.arabicFontSize);
  const translationFontSize = useSelector((state) => state.settings.translationFontSize);
  const scriptStyle = useSelector((state) => state.settings.script);
  const userTheme = useSelector((state) => state.settings.userTheme);
  const rawGlobalShuffle = useSelector((state) => state.settings.shuffle);
  const globalShuffle = rawGlobalShuffle != null ? parseInt(rawGlobalShuffle, 10) : 3;
  const globalRangeFromChapter = useSelector((state) => state.settings.rangeFromChapter);
  const globalRangeToChapter = useSelector((state) => state.settings.rangeToChapter);
  const globalRangeFromVerse = useSelector((state) => state.settings.rangeFromVerse);
  const globalRangeToVerse = useSelector((state) => state.settings.rangeToVerse);
  
  // Internal state management - modal manages its own open/close and verse
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVerse, setSelectedVerse] = useState(null);
  
  const [allVerses, setAllVerses] = useState([]);
  const [nextPageToken, setNextPageToken] = useState("");
  const [loading, setLoading] = useState(true);
  const [FirstVerse, setFirstVerse] = useState(null);
  const [isGrammerModalOpen, setIsGrammerModalOpen] = useState(false);
  const [grammerModalVerse, setGrammerModalVerse] = useState('');
  const [grammerModalVerseId, setGrammerModalVerseId] = useState('');
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [notesData, setNotesData] = useState([]);
  const [deleteNotesId, setDeleteNotesId] = useState(null);
  const [isDeleteConfirmationsModalOpen, setIsDeleteConfirmationsModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isCollectionModalOpen, setIsCollectionModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isAddNewCollectionModalOpen, setIsAddNewCollectionModalOpen] = useState(false);

  const [isBookmarkConfirmationsModalOpen, setIsBookmarkConfirmationsModalOpen] = useState(false);
  const [user, setUser] = useState(auth.currentUser);
  const [showTooltip, setShowTooltip] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(null);
  const [showVerseHoverPopup, setShowVerseHoverPopup] = useState(false);
  const [activeVerseWordIndex, setActiveVerseWordIndex] = useState(false);
  const [activeVerseIndex, setActiveVerseIndex] = useState(false);
  const [currentChapter, setCurrentChapter] = useState(null);
  const [currentVerse, setCurrentVerse] = useState(null);
  const [cursorInsidePopupDiv, setCursorInsidePopupDiv] = useState(false);
  
  // Local audio state for modal - completely independent
  const [localAudioSrc, setLocalAudioSrc] = useState('');
  const [localPlayState, setLocalPlayState] = useState(false);
  const [localPlayingSurah, setLocalPlayingSurah] = useState(null);
  const [localPlayingVerse, setLocalPlayingVerse] = useState(null);
  const [localRecitations, setLocalRecitations] = useState([]);
  const [localFirstVerse, setLocalFirstVerse] = useState([]);
  const [localShuffle, setLocalShuffle] = useState(1); // 1 = normal, 2 = repeat chapter, 3 = all chapters, 4 = range
  const [localOpen, setLocalOpen] = useState(false);
  const [localOpenShuffle, setLocalOpenShuffle] = useState(false);
  const [localRangeOfVerses, setLocalRangeOfVerses] = useState({ fromVerse: 1, toVerse: 1 });
  const [localSelectedSurah, setLocalSelectedSurah] = useState(null);
  const [localPauseThis, setLocalPauseThis] = useState(false);
  
  const audioRef = useRef(null);
  const topOfPageRef = useRef(null);
  const playingVerseRef = useRef(null);
  const selectedVerseRef = useRef(null);
  const lastScrolledModalKey = useRef(null);
  const wordRefs = useRef([]);
  const CopyVerse = userTheme === 'Dark' ? CopyVerseGray : CopyVerseWhite;
  
  // AudioBar UI assets
  const shuffle_Icon = userTheme === 'Dark' ? shuffleIconWhite : shuffleIcon;
  const arrowDownBlue = userTheme === 'Dark' ? arrow_down_White : arrow_down_blue;
  const moveNext = userTheme === 'Dark' ? move_nextWhite : move_next;
  const movePrevious = userTheme === 'Dark' ? move_previousWhite : move_previous;
  const playBlackWhite = userTheme === 'Dark' ? play_White : play_black;
  const pauseBlackWhite = userTheme === 'Dark' ? pause_White : pause_black;
  const ChapterOptions = convertToSearchableChapters(chapters);

  // Support both controlled (props) and uncontrolled (internal state) modes
  // If props are provided, use them (controlled mode - for backward compatibility)
  // Otherwise, use internal state (uncontrolled mode - for future standalone use)
  const isOpen = props.isOpen !== undefined ? props.isOpen : isModalOpen;
  const singleVerse = props.singleVerse !== undefined ? props.singleVerse : selectedVerse;

  const handleClose = () => {
    // Stop local audio when modal closes - completely independent, no global state changes
    if (audioRef.current && audioRef.current.audioEl && audioRef.current.audioEl.current) {
      audioRef.current.audioEl.current.pause();
      audioRef.current.audioEl.current.currentTime = 0;
    }
    setLocalPlayState(false);
    setLocalAudioSrc('');
    setLocalPlayingSurah(null);
    setLocalPlayingVerse(null);
    setLocalRecitations([]);
    
    setIsModalOpen(false);
    setSelectedVerse(null);
    if (props.onClose) {
      props.onClose();
    }
  };

  const getAllTranslations = useCallback(async () => {
    if (!singleVerse) return;
    
    setLoading(true);
    const surah = singleVerse.chapterNo;
    const totalVerses = chapters.chapters[parseInt(surah) - 1]?.totalVerses;

    // Load Bismillah if needed (for surahs other than Al-Fatiha)
    if (parseInt(surah) > 1) {
      let result = await FindAllTranslations(1, 1, selectedReciterId, selectedTranslations);
      if (result && result.status === 200) {
        setFirstVerse(result.data.verse && result.data.verse[0]);
      }
    }
    
    // Load the entire surah starting from verse 1
    let allVersesData = [];
    let currentPageToken = null;
    let hasMorePages = true;
    
    // Start loading from verse 1
    let result = await FindAllTranslations(surah, 1, selectedReciterId, selectedTranslations);
    if (result && result.status) {
      allVersesData = [...result.data.verse];
      currentPageToken = result.data.nextPageToken;
      
      // Keep loading pages until we have all verses or no more pages
      while (currentPageToken && hasMorePages) {
        let paginationResult = await findAllTranslationsWithPagination(currentPageToken);
        if (paginationResult && paginationResult.status) {
          const newVerses = paginationResult.data.verse;
          // Filter to only include verses from the current surah
          const surahVerses = newVerses.filter(v => v.chapterNo === parseInt(surah));
          
          if (surahVerses.length > 0) {
            allVersesData = [...allVersesData, ...surahVerses];
            const lastVerse = surahVerses[surahVerses.length - 1];
            currentPageToken = paginationResult.data.nextPageToken;
            // If we have all verses (last verse number matches totalVerses), stop
            if (totalVerses && lastVerse.verseNo >= totalVerses) {
              hasMorePages = false;
            }
          } else {
            // No more verses from this surah, stop loading
            hasMorePages = false;
          }
        } else {
          hasMorePages = false;
        }
      }
      
      setAllVerses(allVersesData);
      setNextPageToken(currentPageToken);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [singleVerse, selectedReciterId, selectedTranslations, chapters]);

  useEffect(() => {
    if (isOpen && singleVerse) {
      setCurrentChapter(singleVerse.chapterNo);
      setCurrentVerse(singleVerse.verseNo);
      setLocalPlayingSurah(singleVerse.chapterNo);
      setLocalPlayingVerse(singleVerse.chapterNo > 1 && singleVerse.verseNo === 1 ? 1111 : singleVerse.verseNo);
      setLocalSelectedSurah(singleVerse.chapterNo);
      setLocalShuffle(globalShuffle || 1);
      setLocalRangeOfVerses({
        fromChapter: globalRangeFromChapter || 1,
        toChapter: globalRangeToChapter || 1,
        fromVerse: globalRangeFromVerse || 1,
        toVerse: globalRangeToVerse || 5,
      });
      getAllTranslations();
    } else if (!isOpen) {
      // Reset state when modal closes
      setAllVerses([]);
      setFirstVerse(null);
      setCurrentChapter(null);
      setCurrentVerse(null);
      setLocalPlayingSurah(null);
      setLocalPlayingVerse(null);
      setLocalSelectedSurah(null);
    }
  }, [isOpen, singleVerse, getAllTranslations, globalShuffle, globalRangeFromChapter, globalRangeToChapter, globalRangeFromVerse, globalRangeToVerse]);

  // Scroll to selected verse when modal opens and verses are loaded
  useEffect(() => {
    if (isOpen && singleVerse && allVerses.length > 0 && !loading) {
      const currentKey = `${singleVerse.chapterNo}-${singleVerse.verseNo}`;
      if (lastScrolledModalKey.current !== currentKey) {
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          if (selectedVerseRef.current) {
            selectedVerseRef.current.scrollIntoView({ behavior: 'auto', block: 'center' });
            lastScrolledModalKey.current = currentKey;
          }
        }, 100);
      }
    } else if (!isOpen) {
      lastScrolledModalKey.current = null;
    }
  }, [isOpen, singleVerse, allVerses, loading]);

  const findAllTranslationsWithPaginationList = useCallback(async () => {
    if (nextPageToken) {
      let result = await findAllTranslationsWithPagination(nextPageToken);
      if (result && result.status) {
        setAllVerses(prevVerses => [...prevVerses, ...result.data.verse]);
        setNextPageToken(result.data.nextPageToken);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [nextPageToken]);

  const handleScroll = (event) => {
    if (showTooltip && activeImageIndex !== null) {
      setShowTooltip(false);
      setActiveImageIndex(null);
    }
    const target = event.target;
    const threshold = 1;
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + threshold) {
      setLoading(true);
      findAllTranslationsWithPaginationList();
    }
  };

  const scrollToTopOfPage = () => {
    if (topOfPageRef.current) {
      topOfPageRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  };

  const navigateToVerse = async (chapterNo, verseNo) => {
    setCurrentChapter(chapterNo);
    setCurrentVerse(verseNo);
    setLoading(true);
    const result = await FindAllTranslations(chapterNo, verseNo, selectedReciterId, selectedTranslations);
    if (result && result.status) {
      setAllVerses(result.data.verse);
      setNextPageToken(result.data.nextPageToken);
      setLoading(false);
      scrollToTopOfPage();
    }
  };

  const callPlayFunction = async (newPlayingSurah, newPlayingVerse, shouldPause = false) => {
    // Play locally only - completely independent
    const isSameSurah = newPlayingSurah === localPlayingSurah;
    const isSameVerse = newPlayingVerse === localPlayingVerse;
    
    if (isSameSurah && isSameVerse && localPlayState) {
      if (shouldPause) {
        // Pause the local audio
        if (audioRef.current && audioRef.current.audioEl && audioRef.current.audioEl.current) {
          audioRef.current.audioEl.current.pause();
        }
        setLocalPlayState(false);
        setLocalPauseThis(true);
        return;
      }
      // If same verse and already playing, don't restart
      return;
    }
    
    // Play the audio locally
    setLocalPlayingSurah(newPlayingSurah);
    setLocalPlayingVerse(newPlayingVerse === 1111 ? 0 : newPlayingVerse);
    setLocalSelectedSurah(newPlayingSurah);
    setLocalPauseThis(false);

    // Handle special case for Bismillah (1111 or 0)
    if (newPlayingVerse === 1111 || newPlayingVerse === 0) {
      try {
        const response = await fetchRecitationAudio(selectedReciterId, 1, 1, 1);
        if (response && response.status === 200 && response.data?.[0]) {
          setLocalFirstVerse([response.data[0]]);
          setLocalAudioSrc(response.data[0].url);
          setLocalPlayState(true);
        }
      } catch (error) {
        console.error('Error fetching bismillah recitation:', error);
      }
      return;
    }
    
    // Check if we need to fetch recitations for this chapter
    const isDifferentChapter = newPlayingSurah !== localPlayingSurah;
    let recitationsToUse = localRecitations;
    
    if (isDifferentChapter || localRecitations.length === 0) {
      try {
        const totalVerses = chapters.chapters[parseInt(newPlayingSurah) - 1]?.totalVerses || 1;
        const response = await fetchRecitationAudio(selectedReciterId, newPlayingSurah, newPlayingVerse, totalVerses);
        if (response && response.status === 200) {
          recitationsToUse = response.data;
          setLocalRecitations(recitationsToUse);
        }
      } catch (error) {
        console.error('Error fetching recitations:', error);
      }
    }
    
    // Find the audio URL for this verse
    if (recitationsToUse && recitationsToUse.length > 0) {
      const audioItem = recitationsToUse.find(item => item.verseNo === newPlayingVerse && item.chapNo === newPlayingSurah);
      if (audioItem && audioItem.url) {
        setLocalAudioSrc(audioItem.url);
        setLocalPlayState(true);
      } else {
        // If not found, try fetching just this verse
        try {
          const response = await fetchRecitationAudio(selectedReciterId, newPlayingSurah, newPlayingVerse, 1);
          if (response && response.status === 200 && response.data && response.data.length > 0) {
            setLocalAudioSrc(response.data[0].url);
            setLocalPlayState(true);
          }
        } catch (error) {
          console.error('Error fetching audio:', error);
        }
      }
    }
  };

  // Local AudioBar functions - completely independent
  const localPlayVerse = async (playChapterNo, verseIndex, play_pause, resetRecitations) => {
    if (play_pause) {
      await callPlayFunction(playChapterNo, verseIndex, false);
    } else {
      await callPlayFunction(playChapterNo, verseIndex, true);
    }
  };

  const localPause = () => {
    if (audioRef.current && audioRef.current.audioEl && audioRef.current.audioEl.current) {
      audioRef.current.audioEl.current.pause();
    }
    setLocalPlayState(false);
    setLocalPauseThis(true);
  };

  const localPlayNextVerse = async () => {
    if (!localPlayingSurah || localPlayingVerse === null || localPlayingVerse === undefined) return;

    const currentSurah = localPlayingSurah;
    const currentVerse = (localPlayingVerse === 1111 || localPlayingVerse === 0) ? 0 : localPlayingVerse;
    const totalVerses = chapters.chapters[currentSurah - 1]?.totalVerses || 1;

    // Transition Helper
    const playAndCheckPagination = async (surah, verse) => {
      // Check if we need to load more verses
      if (allVerses.length > 0) {
        const lastVerse = allVerses[allVerses.length - 1];
        if (surah === lastVerse.chapterNo && verse > lastVerse.verseNo) {
          await findAllTranslationsWithPaginationList();
        }
      }
      await callPlayFunction(surah, verse, false);
    };

    if (localShuffle === 4) {
      const toChapter = parseInt(localRangeOfVerses.toChapter, 10) || 1;
      const toVerse = parseInt(localRangeOfVerses.toVerse, 10) || 1;

      if (currentVerse === 0) {
        await playAndCheckPagination(currentSurah, 1);
        return;
      }

      if (currentSurah === toChapter && currentVerse === toVerse) {
        localPause();
        return;
      }

      const nextVerse = currentVerse + 1;
      if (nextVerse <= totalVerses) {
        if (currentSurah === toChapter && nextVerse > toVerse) {
          localPause();
          return;
        }
        await playAndCheckPagination(currentSurah, nextVerse);
      } else {
        if (currentSurah < toChapter) {
          const nextChapter = currentSurah + 1;
          await playAndCheckPagination(nextChapter, 1111);
        } else {
          localPause();
        }
      }
      return;
    }

    if (localShuffle === 2) {
      if (currentVerse === 0) {
        await playAndCheckPagination(currentSurah, 1);
        return;
      }
      const nextVerse = currentVerse + 1;
      if (nextVerse <= totalVerses) {
        await playAndCheckPagination(currentSurah, nextVerse);
      } else {
        await playAndCheckPagination(currentSurah, 1);
      }
      return;
    }

    if (localShuffle === 3) {
      if (currentVerse === 0) {
        await playAndCheckPagination(currentSurah, 1);
        return;
      }
      const nextVerse = currentVerse + 1;
      if (nextVerse <= totalVerses) {
        await playAndCheckPagination(currentSurah, nextVerse);
      } else {
        if (currentSurah < 114) {
          const nextChapter = currentSurah + 1;
          await playAndCheckPagination(nextChapter, 1111);
        } else {
          localPause();
        }
      }
      return;
    }

    if (currentVerse === 0) {
      await playAndCheckPagination(currentSurah, 1);
      return;
    }
    const nextVerse = currentVerse + 1;
    if (nextVerse <= totalVerses) {
      await playAndCheckPagination(currentSurah, nextVerse);
    }
  };

  const localPlayPreviousVerse = async () => {
    if (!localPlayingSurah || localPlayingVerse === null || localPlayingVerse === undefined) return;

    const currentSurah = localPlayingSurah;
    const currentVerse = (localPlayingVerse === 1111 || localPlayingVerse === 0) ? 0 : localPlayingVerse;

    if (localShuffle === 4) {
      const fromChapter = parseInt(localRangeOfVerses.fromChapter, 10) || 1;
      const fromVerse = parseInt(localRangeOfVerses.fromVerse, 10) || 1;

      if (currentSurah === fromChapter && currentVerse === fromVerse) {
        return;
      }

      if (currentVerse > 1) {
        const prevVerse = currentVerse - 1;
        if (currentSurah === fromChapter && prevVerse < fromVerse) {
          return;
        }
        await callPlayFunction(currentSurah, prevVerse);
      } else {
        if (currentSurah > fromChapter) {
          const prevChapter = currentSurah - 1;
          const prevTotalVerses = chapters.chapters[prevChapter - 1]?.totalVerses || 1;
          await callPlayFunction(prevChapter, prevTotalVerses);
        }
      }
      return;
    }

    if (localShuffle === 2) {
      if (currentVerse > 1) {
        await callPlayFunction(currentSurah, currentVerse - 1);
      } else {
        const totalVerses = chapters.chapters[currentSurah - 1]?.totalVerses || 1;
        await callPlayFunction(currentSurah, totalVerses);
      }
      return;
    }

    if (localShuffle === 3) {
      if (currentVerse > 1) {
        await callPlayFunction(currentSurah, currentVerse - 1);
      } else {
        if (currentSurah > 1) {
          const prevChapter = currentSurah - 1;
          const prevTotalVerses = chapters.chapters[prevChapter - 1]?.totalVerses || 1;
          await callPlayFunction(prevChapter, prevTotalVerses);
        }
      }
      return;
    }

    if (currentVerse > 1) {
      await callPlayFunction(currentSurah, currentVerse - 1);
    }
  };

  const localHandleReciterChange = (reciterid, recitername) => {
    // Update local reciter - clear recitations to force refetch with new reciter
    setLocalRecitations([]);
    setLocalFirstVerse([]);
    // If currently playing, restart with new reciter
    if (localPlayingSurah && localPlayingVerse !== null) {
      callPlayFunction(localPlayingSurah, localPlayingVerse === 0 ? 1111 : localPlayingVerse);
    }
  };

  const localHandleShuffleChange = (shuffleId) => {
    const activeShuffle = parseInt(shuffleId, 10);
    setLocalShuffle(activeShuffle);
    dispatch(SettingActions.updateSettings({ shuffle: activeShuffle }));
  };

  const localCloseModal = () => {
    setLocalOpen(false);
  };

  const localCloseModalShuffle = () => {
    setLocalOpenShuffle(false);
  };

  const localSetAudioSrcToThis = (url) => {
    setLocalAudioSrc(url);
    setLocalPlayState(true);
  };

  const copyVerse = async (verse) => {
    try {
      // Only include translations when "Show translations" is enabled
      const translationsToCopy = showTranslation ? (verse.translations || []) : [];

      const htmlContent = `
        <div dir="rtl">${verse.text}</div>
        ${translationsToCopy
          .map(t => {
            const dir = getTranslationDirection(t.translationText);
            return `
              <div dir="${dir}">
                ${t.translationText}
                <div style="font-size: 0.8em; color: gray;">— ${t.translator?.translatorName || ''}</div>
              </div>
            `;
          })
          .join("")}
      `;
      const plainText = [
        verse.text,
        ...(translationsToCopy.map(
          t => `${t.translationText} — ${t.translator?.translatorName || ''}`
        ))
      ].join("\n");
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([htmlContent], { type: "text/html" }),
          "text/plain": new Blob([plainText], { type: "text/plain" }),
        }),
      ]);
      message.success(t('verse-coppied'));
    } catch (error) {
      console.error('Failed to copy verse:', error);
      message.error(t('failed-to-copy-verse'));
    }
  };

  const openGrammerModal = (verseGrammer, verseid) => {
    setIsGrammerModalOpen(true);
    setGrammerModalVerse(verseGrammer);
    setGrammerModalVerseId(verseid);
  };

  const closeGrammerModal = () => {
    setIsGrammerModalOpen(false);
  };

  const AddToBookMark = async (verseId, verseNo, chapterNo, chapterName) => {
    HideAddPlusPopup();
    setLoading(true);
    let result = await addToBookmark(verseId, verseNo, chapterNo, chapterName);
    if (result && result.status === 201) {
      const verseToUpdate = allVerses.find((verse) => verse.id === verseId);
      if (verseToUpdate) {
        verseToUpdate.bookmark.push({ 'chapterName': chapterName, 'verseId': verseId, 'chapterNo': chapterNo, 'verseNo': verseNo });
      }
      message.success(t('bookmark-success'));
    }
    setLoading(false);
  };

  const RemoveBookmark = async (verseId) => {
    HideAddPlusPopup();
    if (isBookmarkConfirmationsModalOpen) {
      setIsBookmarkConfirmationsModalOpen(false);
    }
    setLoading(true);
    let result = await deleteBookmark(verseId);
    if (result && result.status === 200) {
      const verseToUpdate = allVerses.find((verse) => verse.id === verseId);
      if (verseToUpdate) {
        verseToUpdate.bookmark = [];
      }
      message.success(t('remove-bookmark-success-msg'));
    }
    setLoading(false);
  };

  const bookmarkDeleteConfirmation = (verseId) => {
    setIsBookmarkConfirmationsModalOpen(true);
    setDeleteNotesId(verseId);
  };

  const AddToNotes = (singleVerse) => {
    setNotesData(singleVerse);
    setIsNotesModalOpen(true);
    HideAddPlusPopup();
  };

  const closeNotesModal = () => {
    setIsNotesModalOpen(false);
  };

  const closeDeleteConfirmationModal = () => {
    setIsDeleteConfirmationsModalOpen(false);
  };

  const closeBookmarkDeleteConfirmationModal = () => {
    setIsBookmarkConfirmationsModalOpen(false);
  };

  const HideAddPlusPopup = () => {
    setShowTooltip(false);
    setActiveImageIndex(null);
  };

  const AddToCollections = (verseId) => {
    HideAddPlusPopup();
    setNotesData([verseId]);
    setIsCollectionModalOpen(true);
  };

  const closeCollectionModal = () => {
    setIsCollectionModalOpen(false);
  };

  const handleMouseLeave = () => {
    setActiveVerseWordIndex(null);
    setActiveVerseIndex(null);
  };

  const removeQuranicSymbols = (verse) => {
    // Define a regular expression pattern to match specific Arabic Unicode characters
    const specificArabicCharsRegex = /[\u0600\u0610\u0640\u0650\u0660\u0670\u06E0\u06F0\u0601\u0611\u0651\u06E1\u0602\u0612\u0652\u06E2\u0603\u0613\u0653\u06E3\u0604\u0614\u0654\u06D4\u06E4\u0605\u0615\u0655\u06E5\u0616\u0656\u06D6\u0617\u0657\u06D7\u06E7\u0618\u0658\u06D8\u06E8\u0619\u0659\u06D9\u06E9\u061A\u065A\u06DA\u06EA\u061B\u064B\u065B\u06DB\u06EB\u064C\u065C\u06DC\u06EC\u061D\u064D\u065D\u066D\u06DD\u06ED\u061E\u064E\u065E\u06DE\u061F\u064F\u065F\u06DF\u06D6\u06D9\u06DA]/g;
    // Replace matched characters with an empty string
    const cleanedString = verse.replace(specificArabicCharsRegex, '');
    return cleanedString;
  };

  // Skip hover-search for tokens that are only tajweed/diacritic symbols.
  const isSearchableArabicWord = (word) => {
    if (!word) return false;
    const stripped = removeQuranicSymbols(String(word)).trim();
    return /[\u0621-\u064A]/.test(stripped);
  };

  const getMappedTranslationIndex = (completeVerse, hoveredIndex) => {
    if (hoveredIndex == null || hoveredIndex < 0) return -1;
    const tokens = String(completeVerse || '').replace(/\s+/g, ' ').trim().split(' ');
    if (!tokens[hoveredIndex] || !isSearchableArabicWord(tokens[hoveredIndex])) return -1;
    let mapped = -1;
    for (let i = 0; i <= hoveredIndex && i < tokens.length; i += 1) {
      if (isSearchableArabicWord(tokens[i])) mapped += 1;
    }
    return mapped;
  };

  const SearchWord = (word, rootWord) => {
    // Close the modal when searching
    handleClose();
    if (rootWord !== null && rootWord !== undefined && rootWord.length > 0) {
      navigate('/search/rootword:' + rootWord);
    } else {
      navigate('/search/' + word);
    }
  };

  const togglePopupOverVerse = (index1, index, word) => {
    if (!isSearchableArabicWord(word)) {
      setShowVerseHoverPopup(false);
      setActiveVerseWordIndex(null);
      setActiveVerseIndex(null);
      return;
    }
    setCursorInsidePopupDiv(true);
    setActiveVerseWordIndex(activeVerseWordIndex === index1 ? null : index1);
    setActiveVerseIndex(index);
    setShowVerseHoverPopup(!showVerseHoverPopup);
  };

  const handleMouseEnterPopup = () => {
    setCursorInsidePopupDiv(true);
  };

  const handleMouseLeavePopup = () => {
    setCursorInsidePopupDiv(false);
  };

  const WordPoup = (word, versewordbywordTranslation, index, complete_verse) => {
    try {
      const selectedWord = getMappedTranslationIndex(complete_verse, index);
      
      if (versewordbywordTranslation === null || versewordbywordTranslation === undefined || 
          selectedWord === -1 || versewordbywordTranslation[selectedWord] === null || 
          versewordbywordTranslation[selectedWord] === undefined) {
        return null;
      }

      let filterString = versewordbywordTranslation[selectedWord].translation;

      if (/-/.test(filterString)) {
        filterString = filterString.replace(/-/g, ' ');
      }
      if (/,/.test(filterString)) {
        filterString = filterString.replace(/,/g, ' ');
      }
      if (/\./.test(filterString)) {
        filterString = filterString.replace(/\./g, ' ');
      }
      filterString = filterString.replace(/\s+/g, ' ').trim();

      return (
        <div className="word_popup_outside_div popuppp ">
          {cursorInsidePopupDiv && (
            <div className={`darkBackground word_popup `}
              onClick={(e) => {
                e.stopPropagation();
                console.log("Popup clicked");
              }}
              onMouseEnter={() => handleMouseEnterPopup()} 
              onMouseLeave={() => handleMouseLeavePopup()} >
              <div className={` w-auto align-self-center pl-2 mr-4 verse-popup-text themePopup `} nowrap="true">
                {word}
              </div>
              <div
                className={`w-auto align-self-center pl-wordpopup-4 verse-popup-text themePopup nowrapword`}
                nowrap="true">
                {filterString}
              </div>
              <div
                className='  w-auto verse_button text-white align-self-center ml-buuton-4 cursor_pointer search-button-verse-popup'
                onClick={() => SearchWord(word, versewordbywordTranslation[selectedWord].root)}
                nowrap="true">
                {(t('search'))}
              </div>
            </div>
          )}
        </div>
      );
    } catch (e) {
      console.log("error is e:", e);
      return null;
    }
  };

  const handlePlusClick = (index) => {
    setShowTooltip(!showTooltip);
    setActiveImageIndex(activeImageIndex === index ? null : index);
  };

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((authUser) => {
      if (authUser) {
        setUser(authUser);
      } else {
        setUser(null);
      }
    });
    return () => {
      unsubscribe();
    };
  }, [user]);

  // Modal is completely independent - no global state syncing

  useEffect(() => {
    if (localPlayState && localAudioSrc && audioRef.current && audioRef.current.audioEl && audioRef.current.audioEl.current && !loading) {
      audioRef.current.audioEl.current.play().catch(error => {
        console.error('Error playing audio:', error);
        setLocalPlayState(false);
      });
    } else if (!localPlayState && audioRef.current && audioRef.current.audioEl && audioRef.current.audioEl.current) {
      audioRef.current.audioEl.current.pause();
    }
  }, [localPlayState, localAudioSrc, loading]);

  // Handle audio end event - automatically play next verse based on shuffle mode
  const handleAudioEnded = async () => {
    // Only continue if we're still supposed to be playing (check local playState)
    if (!localPlayState) {
      return;
    }
    
    // Find next verse
    let nextVerse = (localPlayingVerse === 1111 || localPlayingVerse === 0) ? 1 : localPlayingVerse + 1;
    const currentSurah = localPlayingSurah;
    
    if (!currentSurah || nextVerse === undefined || nextVerse === null) {
      setLocalPlayState(false);
      return;
    }
    
    const totalVerses = chapters.chapters[parseInt(currentSurah) - 1]?.totalVerses;
    
    // Handle different shuffle modes
    if (localShuffle === 2 && localPlayingVerse === localRecitations.length) {
      // Repeat chapter - go back to verse 1
      await callPlayFunction(currentSurah, 1);
      return;
    } else if (localShuffle === 3 && currentSurah < 114 && nextVerse > totalVerses) {
      // All chapters mode - move to next chapter
      await callPlayFunction(currentSurah + 1, 1111);
      return;
    } else if (localShuffle === 4) {
      // Range mode - check if we've reached the end of range
      const rangeToVerse = localRangeOfVerses.toVerse;
      const rangeToChapter = localRangeOfVerses.toChapter || currentSurah;
      if (currentSurah === rangeToChapter && nextVerse > rangeToVerse) {
        // Reached end of range, stop
        setLocalPlayState(false);
        return;
      }
    }
    
    // Check if we need to load more verses
    if (allVerses.length > 0) {
      const lastVerse = allVerses[allVerses.length - 1];
      if (nextVerse > lastVerse.verseNo && currentSurah === lastVerse.chapterNo) {
        // Need to load more verses
        await findAllTranslationsWithPaginationList();
      }
    }
    
    // Check if next verse exists in current chapter
    if (totalVerses && nextVerse <= totalVerses) {
      // Play next verse
      await callPlayFunction(currentSurah, nextVerse);
    } else {
      // Reached end of chapter, stop playing (unless in all chapters mode)
      if (localShuffle !== 3) {
        setLocalPlayState(false);
      }
    }
  };

  // Handle audio play/pause events
  const handleAudioPlay = () => {
    setLocalPlayState(true);
  };

  const handleAudioPause = () => {
    setLocalPlayState(false);
  };

  useEffect(() => {
    if (playingVerseRef.current && jumpToVerse) {
      playingVerseRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, [localPlayingVerse, jumpToVerse]);

  useEffect(() => {
    if (allVerses.length > 0) {
      if (localPlayingVerse && localPlayingVerse > allVerses[allVerses.length - 1].verseNo && localPlayingSurah === allVerses[allVerses.length - 1].chapterNo) {
        findAllTranslationsWithPaginationList();
      }
    }
  }, [allVerses, localPlayingVerse, localPlayingSurah, findAllTranslationsWithPaginationList]);

    return (
    <ReadVerseModalUi
      isOpen={isOpen}
      onClose={handleClose}
      allVerses={allVerses}
      FirstVerse={FirstVerse}
      loading={loading}
      scriptStyle={scriptStyle}
      arabicFontSize={arabicFontSize}
      translationFontSize={translationFontSize}
      showTranslation={showTranslation}
      playingVerse={localPlayingVerse}
      playingSurah={localPlayingSurah}
      playState={localPlayState}
      CopyVerse={CopyVerse}
      audioRef={audioRef}
      localAudioSrc={localAudioSrc}
      handleAudioEnded={handleAudioEnded}
      handleAudioPlay={handleAudioPlay}
      handleAudioPause={handleAudioPause}
      chapters={chapters}
      t={t}
      wordRefs={wordRefs}
      playingVerseRef={playingVerseRef}
      topOfPageRef={topOfPageRef}
      selectedVerseRef={selectedVerseRef}
      handleScroll={handleScroll}
      navigateToVerse={navigateToVerse}
      callPlayFunction={callPlayFunction}
      copyVerse={copyVerse}
      openGrammerModal={openGrammerModal}
      AddToBookMark={AddToBookMark}
      RemoveBookmark={RemoveBookmark}
      bookmarkDeleteConfirmation={bookmarkDeleteConfirmation}
      AddToNotes={AddToNotes}
      closeNotesModal={closeNotesModal}
      closeDeleteConfirmationModal={closeDeleteConfirmationModal}
      closeBookmarkDeleteConfirmationModal={closeBookmarkDeleteConfirmationModal}
      HideAddPlusPopup={HideAddPlusPopup}
      AddToCollections={AddToCollections}
      closeCollectionModal={closeCollectionModal}
      togglePopupOverVerse={togglePopupOverVerse}
      handleMouseLeave={handleMouseLeave}
      WordPoup={WordPoup}
      handlePlusClick={handlePlusClick}
      showTooltip={showTooltip}
      activeImageIndex={activeImageIndex}
      setActiveImageIndex={setActiveImageIndex}
      showVerseHoverPopup={showVerseHoverPopup}
      activeVerseWordIndex={activeVerseWordIndex}
      activeVerseIndex={activeVerseIndex}
      user={user}
      setLoading={setLoading}
      isGrammerModalOpen={isGrammerModalOpen}
      grammerModalVerse={grammerModalVerse}
      grammerModalVerseId={grammerModalVerseId}
      closeGrammerModal={closeGrammerModal}
      updateGrammerVerseId={setGrammerModalVerseId}
      isBookmarkConfirmationsModalOpen={isBookmarkConfirmationsModalOpen}
      deleteNotesId={deleteNotesId}
      isDeleteConfirmationsModalOpen={isDeleteConfirmationsModalOpen}
      notesData={notesData}
      setDeleteNotesId={setDeleteNotesId}
      isNotesModalOpen={isNotesModalOpen}
      setIsDeleteConfirmationsModalOpen={setIsDeleteConfirmationsModalOpen}
      setIsNotesModalOpen={setIsNotesModalOpen}
      currentChapter={currentChapter}
      currentVerse={currentVerse}
      singleVerse={singleVerse}
      // Local AudioBar props
      localReciterNames={reciterNames || []}
      localSelectedReciterId={selectedReciterId}
      localSelectedReciterName={selectedReciterName || ''}
      localShuffle={localShuffle}
      localRecitations={localRecitations}
      localFirstVerse={localFirstVerse}
      localOpen={localOpen}
      setLocalOpen={setLocalOpen}
      localOpenShuffle={localOpenShuffle}
      setLocalOpenShuffle={setLocalOpenShuffle}
      localPauseThis={localPauseThis}
      localHandleReciterChange={localHandleReciterChange}
      localHandleShuffleChange={localHandleShuffleChange}
      localPlayVerse={localPlayVerse}
      localPlayNextVerse={localPlayNextVerse}
      localPlayPreviousVerse={localPlayPreviousVerse}
      localPause={localPause}
      localCloseModal={localCloseModal}
      localCloseModalShuffle={localCloseModalShuffle}
      localSetAudioSrcToThis={localSetAudioSrcToThis}
      localRangeOfVerses={localRangeOfVerses}
      setLocalRangeOfVerses={setLocalRangeOfVerses}
      localSelectedSurah={localSelectedSurah}
      shuffle_Icon={shuffle_Icon}
      arrowDownBlue={arrowDownBlue}
      moveNext={moveNext}
      movePrevious={movePrevious}
      playBlackWhite={playBlackWhite}
      pauseBlackWhite={pauseBlackWhite}
      ChapterOptions={ChapterOptions}
      userTheme={userTheme}
      navigate={navigate}
    />
  );
}

